import Timepreferrences from "./Timepreferrences";
import Select from "react-select";
import GooglePlacesMulti from "components/shared/GooglePlacesMulti";

export default ({
  fields,
  validationErrors,
  handleChange,
  weekPreferences,
  setweekPreferences,
  editData,
  selectedOption,
  setSelectedOption,
  select_options,
  setHomeCourtAddressField,
  homeCourtAddressField,
}) => {
  //home court address
  const handleChangeForm = (index, event) => {
    const newForms = [...homeCourtAddressField];
    newForms[index].home_court_address = event.target.value;
    setHomeCourtAddressField(newForms);
  };

  const handleAddForm = () => {
    setHomeCourtAddressField((prev) => [
      ...prev,
      {
        home_court_address: "",
        home_court_latitude: "",
        home_court_longitude: "",
      },
    ]);
  };
  const handleRemoveForm = (index) => {
    const newForms = [...homeCourtAddressField];
    newForms.splice(index, 1);
    setHomeCourtAddressField(newForms);
  };

  return (
    <>
      <div className="row">
        <div className="form-group col-md-6">
          <label htmlFor="player_classification">
            Preferred Playing Surface
          </label>
          <div className="col-md-12">
            {/* <select
              className="form-select"
              name="preferred_playing_surface"
              onChange={handleChange("preferred_playing_surface")}
              value={fields.preferred_playing_surface}
            >
              <option value="" selected>
                Select{" "}
              </option>
              <option
                value="All"
                selected={
                  fields?.preferred_playing_surface === "All" ? "selected" : ""
                }
              >
                All{" "}
              </option>
              <option
                value="Hard Court"
                selected={
                  fields?.preferred_playing_surface === "Hard Court"
                    ? "selected"
                    : ""
                }
              >
                Hard Court{" "}
              </option>
              <option
                value="Clay"
                selected={
                  fields?.preferred_playing_surface === "Clay" ? "selected" : ""
                }
              >
                Clay{" "}
              </option>
              <option
                value="Indoor"
                selected={
                  fields?.preferred_playing_surface === "Indoor"
                    ? "selected"
                    : ""
                }
              >
                Indoor{" "}
              </option>
            </select> */}
            <Select
              value={selectedOption}
              onChange={setSelectedOption}
              options={select_options}
              isMulti={true}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-6">
          <label htmlFor="player_classification">Home Court Surface Type</label>
          <div className="col-md-12">
            <select
              className="form-select"
              name="home_court_surface_type"
              onChange={handleChange("home_court_surface_type")}
              value={fields.home_court_surface_type}
            >
              <option value="" selected disabled>
                Select{" "}
              </option>
              <option
                value="hardCourt"
                selected={
                  fields?.home_court_surface_type === "hardCourt"
                    ? "selected"
                    : ""
                }
              >
                Hard Court{" "}
              </option>
              <option
                value="clay"
                selected={
                  fields?.home_court_surface_type === "clay" ? "selected" : ""
                }
              >
                Clay{" "}
              </option>
              <option
                value="indoor"
                selected={
                  fields?.home_court_surface_type === "indoor" ? "selected" : ""
                }
              >
                Indoor{" "}
              </option>
              <option
                value="grass"
                selected={
                  fields?.home_court_surface_type === "grass" ? "selected" : ""
                }
              >
                Grass{" "}
              </option>
            </select>
          </div>
        </div>
        <div className="form-group col-md-6">
          <label htmlFor="player_classification">Play Mode</label>
          <div className="col-md-12">
            <select
              className="form-select"
              name="playing_mode"
              onChange={handleChange("playing_mode")}
              value={fields.playing_mode}
            >
              <option value="" selected disabled>
                Select{" "}
              </option>
              <option
                value="all"
                selected={fields?.playing_mode === "all" ? "selected" : ""}
              >
                All{" "}
              </option>
              <option
                value="singles"
                selected={fields?.playing_mode === "singles" ? "selected" : ""}
              >
                Singles{" "}
              </option>
              <option
                value="doubles"
                selected={fields?.playing_mode === "doubles" ? "selected" : ""}
              >
                Doubles{" "}
              </option>
              <option
                value="mixedDoubles"
                selected={
                  fields?.playing_mode === "mixedDoubles" ? "selected" : ""
                }
              >
                Mixed Doubles{" "}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-6">
          <label htmlFor="player_classification">Max Opponent Age Range</label>
          <div className="col-md-12">
            <input
              type="number"
              className="form-control"
              id="exampleInputName1"
              placeholder=""
              name="max_opponent_age"
              min={0}
              onChange={handleChange("max_opponent_age")}
              value={fields.max_opponent_age}
            />
          </div>
        </div>
        <div className="form-group col-md-6">
          <label htmlFor="player_classification">Min Opponent Age Range</label>
          <div className="col-md-12">
            <input
              type="number"
              className="form-control"
              id="exampleInputName1"
              placeholder=""
              min={0}
              // max={fields.max_opponent_age}
              name="min_opponent_age"
              onChange={handleChange("min_opponent_age")}
              value={fields.min_opponent_age}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="form-group col-md-6">
          <label htmlFor="opponent_gender">Preferred Opponent Gender</label>
          <div className="col-md-12">
            <select
              className="form-select"
              name="gender"
              onChange={handleChange("opponent_gender")}
              value={fields.opponent_gender}
            >
              <option value="" selected>
                Select{" "}
              </option>
              <option
                value="1"
                selected={fields?.opponent_gender === "1" ? "selected" : ""}
              >
                Male{" "}
              </option>
              <option
                value="2"
                selected={fields?.opponent_gender === "2" ? "selected" : ""}
              >
                Female{" "}
              </option>
              <option
                value="3"
                selected={fields?.opponent_gender === "3" ? "selected" : ""}
              >
                Other{" "}
              </option>
            </select>
          </div>
        </div>
        <div className="form-group col-md-6">
          <div className="d-flex align-items-center justify-content-between">
            <div className="left">
              <label htmlFor="name" className="m-0">
                Home Court Address
              </label>
            </div>
            <div className="right">
              <button
                type="button"
                className="btn btn-gradient-primary btn-sm"
                onClick={handleAddForm}
              >
                {" "}
                + Add
              </button>
            </div>
          </div>
          <br />
          <div>
            {homeCourtAddressField?.map((form, index) => (
              <div className="row align-items-center">
                <div className="col-md-11 my-2" key={index}>
                  <GooglePlacesMulti
                    setHomeCourtAddressField={setHomeCourtAddressField}
                    homeCourtAddressField={form.home_court_address}
                    fieldNames={[
                      "home_court_address",
                      "home_court_latitude",
                      "home_court_longitude",
                    ]}
                    onChange={(event) => handleChangeForm(index, event)}
                  />
                </div>
                {index > 0 && (
                  <div className="col-md-1 my-2">
                    <button
                      type="button"
                      className="bg-transparent border-0 p-0"
                      onClick={() => handleRemoveForm(index)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                      >
                        <path
                          d="M10.7876 28.3333C10.1359 28.3333 9.59192 28.1152 9.15559 27.6788C8.71831 27.2415 8.49967 26.6971 8.49967 26.0454V8.49999H7.08301V7.08333H12.7497V5.99249H21.2497V7.08333H26.9163V8.49999H25.4997V26.0454C25.4997 26.6971 25.2815 27.2411 24.8452 27.6774C24.4079 28.1147 23.8634 28.3333 23.2118 28.3333H10.7876ZM13.8943 24.0833H15.311V11.3333H13.8943V24.0833ZM18.6883 24.0833H20.105V11.3333H18.6883V24.0833Z"
                          fill="#C51212"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Timepreferrences
        weekPreferences={weekPreferences}
        setweekPreferences={setweekPreferences}
        editData={editData}
      />
    </>
  );
};
